import Mousetrap from 'mousetrap';
import { EditFormHandler } from './edit-form-handler.js';
import UIUtils from './ui-utils.js';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

export default class ControlBarHandlers {
    constructor() {
        this.selectedItems = [];
        this.initEventListeners();
        this.bindKeyboardShortcuts();
    }

    initEventListeners() {

        const buttonHandlers = [

            { selector: '.btn-set-add-to-lightbox', handler: () => this.handleSetAddToLightbox() },
            { selector: '.btn-set-remove-from-lightbox', handler: () => this.handleRemoveFromLightbox() },
            { selector: '.btn-delete-selected', handler: () => this.handleDeleteSelected() },
            { selector: '.btn-set-main-image', handler: () => this.handleSetMainImage() },
            { selector: '.btn-add-to-index', handler: () => this.handleAddToLiveIndex() },
            { selector: '.btn-set-metadata', handler: () => this.handleSetMetadata() },
            { selector: '.btn-make-promo', handler: () => this.handleMakePromo() },

            { selector: '.btn-filter-calendar', handler: () => this.handleCalendarsFilter() },
            { selector: '.btn-filter-automations', handler: () => this.handleAutomationsFilter() },
            { selector: '.btn-filter-groups', handler: () => this.handleGroupsFilter() },
            { selector: '.btn-filter-groups-clear', handler: () => this.handleClearGroupsFilters() },
            { selector: '.btn-filter-pictures', handler: () => this.handlePicturesFilter() },
            { selector: '.btn-filter-pictures-clear', handler: () => this.handleClearPicturesFilters() },
            { selector: '.btn-filter-eventlogs', handler: () => this.handleEventLogsFilter() },
            { selector: '.btn-filter-publish-history', handler: () => this.handlePublishHistoryFilter() },
            { selector: '.btn-filter-reject-samples', handler: () => this.handleRejectSamplesFilter() },

        ];

        buttonHandlers.forEach(({ selector, handler }) => {
            const button = document.querySelector(selector);
            if (button) {
                button.addEventListener('click', handler);
            }
        });

        // Listen for the custom event to open item details
        document.addEventListener('openItemDetails', (event) => {
            this.openSingleMetadataModal(event.detail.itemElement);
        });
    }

    bindKeyboardShortcuts() {

        Mousetrap.bind('del', () => this.handleDeleteSelected());

        // Add keyboard shortcuts for adding to and removing from lightbox
        Mousetrap.bind('alt+l', () => this.handleSetAddToLightbox());
        Mousetrap.bind('alt+r', () => this.handleRemoveFromLightbox());
        Mousetrap.bind('alt+x', () => this.handleDeleteSelected());
        Mousetrap.bind('alt+o', () => this.handleSetMainImage());
        Mousetrap.bind('alt+i', () => this.handleAddToLiveIndex());
        Mousetrap.bind('alt+m', () => this.handleSetMetadata());
        Mousetrap.bind('alt+p', () => this.handleMakePromo());

    }

    updateSelectedItems(selectedItems) {
        this.selectedItems = selectedItems;
        this.updateControlsBar();
    }

    getPostData() {

        //const contributorIdInput = document.getElementById('contributorId');
        //const contributorId = contributorIdInput ? contributorIdInput.value : null;

        //const hostIdInput = document.getElementById('hostId');
        //const hostId = hostIdInput ? hostIdInput.value : null;

        //const apiUrlInput = document.getElementById('apiUrl');
        //const apiUrl = apiUrlInput ? apiUrlInput.value : null;

        const itemIds = this.selectedItems.map(item => item.getAttribute('data-id'));

        return {
            ItemIds: itemIds,
            //ContributorId: contributorId,
            //HostId: hostId,
            //ApiUrl: apiUrl
        };
    }

    handleBrowseFilter() {

        const modal = UIUtils.openModal('/modal/browse-filters', {}, () => {

            console.log('Opened browse filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/browse-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied browse filters');
                        //this.reloadBrowseList();
                        /*window.location.reload();*/

                        const currentUrl = window.location.origin + window.location.pathname;
                        window.location.href = currentUrl;

                        //Reload browse filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();

                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleCalendarsFilter() {

        const modal = UIUtils.openModal('/modal/calendar-filters', {}, () => {

            console.log('Opened calendars filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/calendar-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied calendar filters');

                        const currentUrl = window.location.origin + window.location.pathname;
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-calendar');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearCalendarFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearFilters(modal) {
        fetch('/browse-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    //this.reloadBrowseList();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }

    handleClearCalendarFilters(modal) {
        fetch('/calendar-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }

    handleAutomationsFilter() {

        const modal = UIUtils.openModal('/modal/automation-filters', {}, () => {

            console.log('Opened automations filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/automation-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied automations filters');

                        const currentUrl = window.location.origin + window.location.pathname;
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-automations');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearAutomationFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearAutomationFilters(modal) {
        fetch('/automation-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }


    handleGroupsFilter() {

        const button = document.querySelector('.btn-filter-groups');

        // Check if the button contains the "global" class
        const isGlobal = button.classList.contains('global');

        // Set the endpoint URL based on whether the "global" class is present
        const modalUrl = isGlobal ? '/modal/groups-filters/global' : '/modal/groups-filters';

        const modal = UIUtils.openModal(modalUrl, {}, () => {

            console.log('Opened groups filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/groups-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied groups filters');

                        // Get the current query string
                        const urlParams = new URLSearchParams(window.location.search);

                        // Remove the "p" parameter if it exists
                        urlParams.delete('p');

                        // Construct the new URL with the updated query string
                        const currentUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-groups');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearGroupsFilters());
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearGroupsFilters() {
        fetch('/groups-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }


    handlePicturesFilter() {

        const modal = UIUtils.openModal('/modal/pictures-filters', {}, () => {

            console.log('Opened pictures filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/pictures-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied pictures filters');

                        // Get the current query string
                        const urlParams = new URLSearchParams(window.location.search);

                        // Remove the "p" parameter if it exists
                        urlParams.delete('p');

                        // Construct the new URL with the updated query string
                        const currentUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-pictures');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearPicturesFilters());
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearPicturesFilters() {
        fetch('/pictures-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }



    handleEventLogsFilter() {

        const modal = UIUtils.openModal('/modal/eventlogs-filters', {}, () => {

            console.log('Opened event logs filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/eventlogs-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied event logs filters');

                        // Get the current query string
                        const urlParams = new URLSearchParams(window.location.search);

                        // Remove the "p" parameter if it exists
                        urlParams.delete('p');

                        // Construct the new URL with the updated query string
                        const currentUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-eventlogs');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearEventLogsFilters(modal));
            }
        },
            () => { },
            () => { return true; });
    }

    handlePublishHistoryFilter() {

        const modal = UIUtils.openModal('/modal/publish-history-filters', {}, () => {

            console.log('Opened publish history filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/publish-history-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied publish history filters');

                        // Get the current query string
                        const urlParams = new URLSearchParams(window.location.search);

                        // Remove the "p" parameter if it exists
                        urlParams.delete('p');

                        // Construct the new URL with the updated query string
                        const currentUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-publish-history');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearPublishHistoryFilters(modal));
            }

            // Handle sort direction toggle
            const sortDirectionButton = modal.modal.querySelector('.btn-sort-direction');
            const sortDirectionInput = modal.modal.querySelector('#SortDirection');
            const ascIcon = sortDirectionButton.querySelector('.ti-sort-ascending-2');
            const descIcon = sortDirectionButton.querySelector('.ti-sort-descending-2');

            // Function to update the sort direction and icons
            const updateSortDirection = () => {
                const isAsc = sortDirectionInput.value === 'asc';
                ascIcon.classList.toggle('hidden', !isAsc);
                descIcon.classList.toggle('hidden', isAsc);
            };

            // Initialize the icon state
            updateSortDirection();

            // Add click event to toggle sort direction
            sortDirectionButton.addEventListener('click', () => {
                sortDirectionInput.value = sortDirectionInput.value === 'asc' ? 'desc' : 'asc';
                updateSortDirection();
            });
        },
            () => { },
            () => { return true; });
    }

    handleClearPublishHistoryFilters(modal) {
        fetch('/publish-history-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }

    handleClearEventLogsFilters(modal) {
        fetch('/eventlogs-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }







    handleRejectSamplesFilter() {

        const modal = UIUtils.openModal('/modal/reject-samples-filters', {}, () => {

            console.log('Opened reject samples filters modal');

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/reject-samples-filters-apply';
                new EditFormHandler(formElement, endpoint, "browse-filters");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();
                        console.log('Applied reject samples filters');

                        // Get the current query string
                        const urlParams = new URLSearchParams(window.location.search);

                        // Remove the "p" parameter if it exists
                        urlParams.delete('p');

                        // Construct the new URL with the updated query string
                        const currentUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
                        window.location.href = currentUrl;

                        //Reload filters

                        UIUtils.toast('success', 'Filters updated.', () => {
                            //window.location.reload();
                        });
                    }
                }, { once: true });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Register the clear filters button handler here
            const clearFiltersButton = modal.modal.querySelector('.btn-clear-filters-reject-samples');
            if (clearFiltersButton) {
                clearFiltersButton.addEventListener('click', () => this.handleClearRejectSamplesFilters(modal));
            }
        },
            () => { },
            () => { return true; });
    }

    handleClearRejectSamplesFilters(modal) {
        fetch('/reject-samples-clear-filters', { method: 'POST' })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {

                    console.log('Filters cleared successfully');

                    window.location.reload();

                    UIUtils.toast('success', 'Cleared filters.', () => {
                        //window.location.reload();
                    });

                } else {
                    console.error('Failed to clear filters');
                }
            })
            .catch(error => {
                console.error('Error clearing filters:', error);
            });
    }






    handleSetMainImage() {

        if (this.selectedItems.length !== 1) {
            return;
        }

        // Remove the .main class from all items
        const items = document.querySelectorAll('.items-list .item');
        items.forEach(item => {
            item.classList.remove('main');
        });

        // Add the .main class to the selected item
        const selectedItem = this.selectedItems[0];
        selectedItem.classList.add('main');

        // Dispatch a custom event with the data-id of the selected item
        const mainItemId = selectedItem.getAttribute('data-id');
        const event = new CustomEvent('mainImageSet', { detail: { id: mainItemId } });
        document.dispatchEvent(event);

        this.clearSelection();
        this.hideControlsBar();
    }


    handleDeleteSelected() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal('/modal/delete-selected', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/delete-selected-confirmed';
                new EditFormHandler(formElement, endpoint, "delete-selected");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();

                        UIUtils.toast('success', 'Deleted selected items.', () => {
                            window.location.reload();
                        });
                    }
                    else {

                        var message = e.detail.message ?? 'An error occurred while deleting selected items.';

                        UIUtils.toast('error', message);
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleAddToLiveIndex() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        const modal = UIUtils.openModal('/modal/add-to-index', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/add-to-index-confirmed';
                new EditFormHandler(formElement, endpoint, "index-selected");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();

                        UIUtils.toast('success', 'Indexing selected items.', () => {
                            window.location.reload();
                        });
                    }
                    else {

                        var message = e.detail.message ?? 'An error occurred while adding selected items to live index.';

                        UIUtils.toast('error', message);
                    }
                }, { once: true });
            }
        },
            () => { },
            () => { return true; });
    }

    handleMakePromo() {

        if (this.selectedItems.length === 0) {
            return;
        }

        // Check if more than 1 item is selected and at least one item has the ".main" class
        if (this.selectedItems.length > 1) {
            const hasMain = this.selectedItems.some(item => item.classList.contains('main'));
            if (!hasMain) {
                UIUtils.toast('error', "Please select a main picture for the promo");
                return;
            }
        }

        const postData = this.getPostData();

        // Find the main image item and add it to postData
        const mainItem = this.selectedItems.find(item => item.classList.contains('main'));
        const mainImageId = mainItem ? mainItem.getAttribute('data-id') : null;
        postData.MainImageId = mainImageId;

        const modal = UIUtils.openModal('/modal/make-promo', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => modal.close());
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/modal/make-promo-confirmed';

                // Initialize EditFormHandler with custom validation logic
                const editFormHandler = new EditFormHandler(
                    formElement,
                    endpoint,
                    "make-promo",
                    null,
                    () => {
                        // Custom validation: ensure at least one category is selected
                        const selectedCategories = modal.modal.querySelectorAll('.content-tag.on');
                        if (selectedCategories.length === 0) {
                            UIUtils.toast('error', "Please select at least one category for the promo.");
                            return false;
                        }
                        return true; // Validation passed
                    }
                );

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        modal.close();

                        UIUtils.toast('success', 'Creating a promo.', () => {
                            window.location.reload();
                        });
                    }
                    else {
                        var message = e.detail.message ?? 'An error occurred while creating a promo.';
                        UIUtils.toast('error', message);
                    }
                },
                    { once: true });

                // Add submit event listener to validate the category selection
                formElement.addEventListener('submit', (e) => {

                    console.log('called here');

                    const selectedCategories = modal.modal.querySelectorAll('.content-tag.on');
                    if (selectedCategories.length === 0) {
                        e.preventDefault();
                        UIUtils.toast('error', "Please select at least one category for the promo.");
                        return false;
                    }
                    return true; // Continue with form submission if at least one category is selected
                });
            }

            // Add event listeners to toggle the "on" class for content-tag elements
            const contentTags = modal.modal.querySelectorAll('.content-tag');
            contentTags.forEach(tag => {
                tag.addEventListener('click', () => {
                    tag.classList.toggle('on');
                });
            });

            // Add event listener for clicking on a .headline.suggested element
            const suggestedHeadlines = modal.modal.querySelectorAll('.headline.suggested');
            if (suggestedHeadlines.length > 0) {
                suggestedHeadlines.forEach(suggested => {
                    suggested.addEventListener('click', () => {

                        const headlineInput = modal.modal.querySelector('#Headline');

                        if (headlineInput) {
                            headlineInput.value = suggested.textContent.trim();
                        }
                    });
                });
            }

            const generateButton = modal.modal.querySelector('.btn-generate-text');
            if (generateButton) {
                generateButton.addEventListener('click', () => this.handleGenerateText());
            }
        },
            () => { },
            () => { return true; });
    }

    handleGenerateText() {
        const generateButton = document.querySelector('.btn-generate-text');
        const formElement = document.querySelector('#modalForm');
        const suggestedHeadlinesBlock = document.querySelector('.suggested-headlines');

        if (!generateButton || !formElement) {
            UIUtils.toast('error', 'Failed to initialize text generation.');
            return;
        }

        // Disable the button and show a loading message
        generateButton.disabled = true;
        generateButton.textContent = 'Generating...';
        UIUtils.toast('info', 'Generating text...');

        // Convert form data to JSON
        const formData = new FormData(formElement);
        const postData = {};

        formData.forEach((value, key) => {
            postData[key] = value; // Populate the postData object
        });

        // Send POST request with JSON payload
        fetch('/modal/generate-promo-text', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'RequestVerificationToken': postData.__ReqVfTok, // Pass CSRF token here
            },
            body: JSON.stringify(postData), // Convert postData to JSON string
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to generate text. Please try again.');
                }
                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    const headlinesContainer = document.querySelector('.headlines');
                    const descriptionInput = document.querySelector('#Description');

                    // Populate the "headlines" UL with the returned headlines
                    if (data.headlines && data.headlines.length > 0 && headlinesContainer) {
                        headlinesContainer.innerHTML = ''; // Clear existing headlines
                        data.headlines.forEach((headline) => {
                            const li = document.createElement('li');
                            li.className =
                                'headline suggested dark:text-emerald-400 hover:dark:text-emerald-300 text-lg pb-2 cursor-pointer';
                            li.textContent = headline;
                            li.addEventListener('click', () => {
                                const headlineInput = document.querySelector('#Headline');
                                if (headlineInput) headlineInput.value = headline.trim();
                            });
                            headlinesContainer.appendChild(li);
                        });

                        // Show the suggested headlines block
                        suggestedHeadlinesBlock.classList.remove('hidden');
                    } else {
                        suggestedHeadlinesBlock.classList.add('hidden');
                    }

                    // Populate the description field
                    if (descriptionInput && data.description) {
                        descriptionInput.value = data.description;
                    }

                    // Show success message
                    UIUtils.toast('success', 'Text generated successfully!');
                } else {
                    const message = data.message || 'Failed to generate text.';
                    UIUtils.toast('error', message);
                }
            })
            .catch((error) => {
                console.error('Error generating text:', error);
                UIUtils.toast('error', error.message || 'An error occurred while generating text.');
            })
            .finally(() => {
                // Re-enable the button
                generateButton.disabled = false;
                generateButton.textContent = 'Generate Text';
            });
    }

    async handleSetAddToLightbox() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        try {
            const response = await fetch('/api/group-view/add-to-lightbox', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData),
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok, status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                this.selectedItems.forEach(item => {
                    item.classList.add('lightbox');
                });

                UIUtils.toast('success', `Added ${this.selectedItems.length} items to lightbox.`);
                this.updateLightboxCount(result.data.itemsCount);
                this.clearSelection();
                this.hideControlsBar();

            } else {
                console.error('Failed to add items to lightbox:', result.message);
                UIUtils.toast('error', 'Failed to add items to lightbox.');
            }
        } catch (error) {
            console.error('Error adding items to lightbox:', error);
            UIUtils.toast('error', 'An error occurred while adding items to lightbox.');
        }
    }

    async handleRemoveFromLightbox() {

        if (this.selectedItems.length === 0) {
            return;
        }

        const postData = this.getPostData();

        try {

            const response = await fetch('/api/group-view/remove-from-lightbox', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(postData),
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok, status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {

                this.selectedItems.forEach(item => {
                    item.classList.remove('lightbox');
                });

                UIUtils.toast('success', `Removed ${this.selectedItems.length} items from lightbox.`);

                this.updateLightboxCount(result.data.itemsCount);
                this.clearSelection();
                this.hideControlsBar();

            } else {
                console.error('Failed to remove items from lightbox:', result.message);
                UIUtils.toast('error', 'Failed to remove items from lightbox.');
            }
        } catch (error) {
            console.error('Error removing items from lightbox:', error);
            UIUtils.toast('error', 'An error occurred while removing items from lightbox.');
        }
    }

    handleSetMetadata() {
        if (this.selectedItems.length === 1) {

            // Use the single-item metadata modal
            const itemElement = this.selectedItems[0];
            this.openSingleMetadataModal(itemElement);
        }
        else if (this.selectedItems.length > 1) {

            // Handle the bulk metadata update
            this.openBulkMetadataModal();
        }
    }

    removeExistingFlatpickrInstances() {
        const existingCalendars = document.querySelectorAll('.flatpickr-calendar');
        existingCalendars.forEach(calendar => calendar.remove());
    };

    openSingleMetadataModal(itemElement) {
        const itemId = itemElement.dataset.id;
        const modalUrl = `/modal/image-details/${itemId}`;

        const modal = UIUtils.openModal(modalUrl,
            null,
            () => {

                const cancelButton = modal.modal.querySelector('.cancel-btn');

                if (cancelButton) {
                    cancelButton.addEventListener('click', () => modal.close());
                }

                const formElement = modal.modal.querySelector('#modalForm');

                if (formElement) {
                    const endpoint = `/modal/update-image-details/${itemId}`;
                    new EditFormHandler(formElement, endpoint, "item-updated");

                    document.addEventListener('formSaved', (e) => {
                        if (e.detail && e.detail.success) {
                            UIUtils.toast('success', 'Item details updated successfully.');
                        } else {
                            const message = e.detail.message ?? 'An error occurred while updating item details.';
                            UIUtils.toast('error', message);
                        }
                    });
                }

                const lblDateCreated = modal.modal.querySelector('#lblDateCreated');
                const creationTimeInput = modal.modal.querySelector('#CreationTime');

                if (lblDateCreated) {

                    // Initialize Flatpickr
                    flatpickr("#lblDateCreated", {
                        mode: "single",
                        dateFormat: "d-m-Y",
                        defaultDate: lblDateCreated.innerText.trim(),
                        onChange: (selectedDates) => {
                            if (selectedDates.length > 0) {
                                const selectedDate = selectedDates[0];

                                // Format the selected date as "dd-MM-yyyy"
                                const day = String(selectedDate.getDate()).padStart(2, '0');
                                const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                                const year = selectedDate.getFullYear();
                                const formattedSelectedDate = `${day}-${month}-${year}`;

                                // Update the innerText of the lblDateCreated element
                                lblDateCreated.innerText = formattedSelectedDate;

                                // Update the hidden input with the formatted date
                                creationTimeInput.value = formattedSelectedDate;
                            }
                        }
                    });
                }
            },
            () => {
                this.removeExistingFlatpickrInstances();
            },
            () => true
        );
    }

    openBulkMetadataModal() {

        const postData = this.getPostData();

        const modal = UIUtils.openModal('/modal/bulk-update-metadata', postData, () => {

            const cancelButton = modal.modal.querySelector('.cancel-btn');

            if (cancelButton) {
                cancelButton.addEventListener('click', () => {
                    if (modal.modal && document.body.contains(modal.modal)) {
                        modal.close();
                    }
                });
            }

            const formElement = modal.modal.querySelector('#modalForm');

            if (formElement) {

                const endpoint = '/modal/bulk-update-metadata-confirmed';
                new EditFormHandler(formElement, endpoint, "bulk-metadata-updated");

                document.addEventListener('formSaved', (e) => {

                    if (e.detail && e.detail.success) {

                        UIUtils.toast('success', 'Metadata updated for selected items.');
                        if (modal.modal && document.body.contains(modal.modal)) {
                            modal.close();
                        }
                        this.clearSelection();
                        this.hideControlsBar();
                    }
                    else {
                        const message = e.detail.message ?? 'An error occurred while updating metadata.';
                        UIUtils.toast('error', message);
                    }
                }, { once: true });
            }

            const lblDateCreated = modal.modal.querySelector('#lblDateCreated');
            const creationTimeInput = modal.modal.querySelector('#CreationTime');

            if (lblDateCreated) {

                // Initialize Flatpickr
                flatpickr("#lblDateCreated", {
                    mode: "single",
                    dateFormat: "d-m-Y",
                    defaultDate: lblDateCreated.innerText.trim(),
                    onChange: (selectedDates) => {
                        if (selectedDates.length > 0) {
                            const selectedDate = selectedDates[0];

                            // Format the selected date as "dd-MM-yyyy"
                            const day = String(selectedDate.getDate()).padStart(2, '0');
                            const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
                            const year = selectedDate.getFullYear();
                            const formattedSelectedDate = `${day}-${month}-${year}`;

                            // Update the innerText of the lblDateCreated element
                            lblDateCreated.innerText = formattedSelectedDate;

                            // Update the hidden input with the formatted date
                            creationTimeInput.value = formattedSelectedDate;
                        }
                    }
                });
            }
        },
            () => {
                if (modal.modal && document.body.contains(modal.modal)) {
                    modal.destroy();  // Safely destroy the modal
                }
                this.removeExistingFlatpickrInstances();
            },
            () => true
        );
    }

    updateControlsBar() {

        const addToLightboxButton = document.querySelector('.btn-set-add-to-lightbox');
        const removeFromLightboxButton = document.querySelector('.btn-set-remove-from-lightbox');
        const setMainImageButton = document.querySelector('.btn-set-main-image');

        // Check if any selected items are already in the lightbox
        if (addToLightboxButton && removeFromLightboxButton) {
            const anyInLightbox = this.selectedItems.some(item => item.classList.contains('lightbox'));

            if (anyInLightbox) {
                addToLightboxButton.classList.add('hidden');
                removeFromLightboxButton.classList.remove('hidden');
            } else {
                addToLightboxButton.classList.remove('hidden');
                removeFromLightboxButton.classList.add('hidden');
            }
        }

        // Show "Main Image" button only if exactly one item is selected
        if (setMainImageButton) {
            if (this.selectedItems.length === 1) {
                setMainImageButton.classList.remove('hidden');
            } else {
                setMainImageButton.classList.add('hidden');
            }
        }

        // Display the controls bar if any items are selected
        const controlsBar = document.querySelector('.controls-bar');
        if (this.selectedItems.length > 0) {
            controlsBar.classList.remove('hidden');
        } else {
            controlsBar.classList.add('hidden');
        }
    }

    updateLightboxCount(count) {
        const lightboxCountElement = document.querySelector('.lightbox-count');
        if (lightboxCountElement) {
            lightboxCountElement.textContent = count.toString();
        }
    }

    clearSelection() {
        // Remove selection from all items
        this.selectedItems.forEach(item => {
            item.classList.remove('selected');
        });

        // Reset the selectedItems array
        this.selectedItems = [];

        // Update the UI to reflect that no items are selected
        document.getElementById('selected-count').textContent = '0';

        // Optionally, hide or disable controls that should only be active when items are selected
        this.toggleControls(false);
    }

    toggleControls(enable) {
        // Example method to enable/disable controls
        const controls = document.querySelectorAll('.controls-bar .bulk');
        controls.forEach(control => {
            if (enable) {
                control.classList.remove('disabled');
            } else {
                control.classList.add('disabled');
            }
        });
    }

    hideControlsBar() {
        const controlsBar = document.querySelector('.controls-bar');
        if (controlsBar) {
            controlsBar.classList.add('hidden');
        }
    }
}